import React from 'react';
import { Route } from 'react-router-dom';

import PageLoader from 'components/Shared/PageLoader';
import { useAuthReady } from 'hooks/useAuthReady';

const Gateway = ({ component: Component, ...rest }: any) => {
  const { isLoading, hasUser } = useAuthReady();

  // Gate apenas autenticação (token + usuário). A restrição por produtor
  // é feita por rota (AuthenticatedRoutes) e por item de menu (PrivateLayout),
  // permitindo que não-produtores acessem /home e /event por exemplo
  if (isLoading || !hasUser) {
    return <PageLoader />;
  }

  return <Route {...rest} render={props => <Component classes={rest.classes} {...props} />} />;
};
export default Gateway;
